import React from 'react';
import { Grid, Box } from '@material-ui/core';
import {
  Quotation,
  QuotationUnit,
  CoverageCatalog,
  CoverageCatalogResume,
} from 'data-layer-cr/dist/models';
import {
  PriceInformacionCard,
  VehicleInformationCard,
  ContractingInformationCard,
  BenefitsInformationCard,
  CoveragesInformationCard,
} from '../InformationCards';

type Props = {
  quotation: Quotation;
  unit: QuotationUnit;
  coverageCatalogs: CoverageCatalog[];
  coverageCatalogResumes: CoverageCatalogResume[];
  paymentAmount: number;
  additionalBenefits?: CoverageCatalog[];
};

const CollectiveDesktopDisplay = ({
  quotation,
  unit,
  coverageCatalogs,
  coverageCatalogResumes,
  paymentAmount,
  additionalBenefits,
}: Props): JSX.Element => {
  return (
    <>
      <Grid item xs={12} md={4}>
        <PriceInformacionCard
          data-testid="price-information-card"
          title="Precio"
          quotation={quotation}
          paymentAmount={paymentAmount}
          unit={unit}
          coverageCatalogs={coverageCatalogs}
          coverageCatalogResumes={coverageCatalogResumes}
        />
      </Grid>

      <Grid item xs={12} md={4}>
        <Box mb={3}>
          <VehicleInformationCard
            data-testid="vehicle-information-card"
            quotation={quotation}
          />
        </Box>

        <Box mb={3}>
          <ContractingInformationCard
            data-testid="contracting-information-card"
            quotation={quotation}
          />
        </Box>

        <Box mb={3}>
          <BenefitsInformationCard
            data-testid="benefits-information-card"
            quotation={quotation}
            productCoverages={unit.coverages}
            coverageCatalogs={coverageCatalogs}
            additionalBenefits={additionalBenefits}
          />
        </Box>
      </Grid>

      <Grid item xs={12} md={4}>
        <CoveragesInformationCard
          data-testid="coverages-information-card"
          quotation={quotation}
          unit={unit}
          coverageCatalogs={coverageCatalogs}
          coverageCatalogResumes={coverageCatalogResumes}
        />
      </Grid>
    </>
  );
};

export default CollectiveDesktopDisplay;
